import { toggleFieldAttributeV2 as toggleFieldAttribute } from 'commonAssets/lib/toggleFieldAttributeV2';
import { toggleForeignPhone } from 'commonAssets/lib/toggleForeignPhone.js';

/**
 * @param {*} member 
 * @param {*} config 
 */
export default function loadMember(member, config) {

    const claimFields = member.claim_fields || [];
    const claimTransactions = member.claim_transactions || [];
    const claimFiles = member.claim_files || [];

    for (const field of claimFields) {
        let input = document.querySelector(`[data-label="${field.name}"]`); // RH - case radio would fail since this was a const
        if (!input) continue;

        switch (input.type) {
            case 'text':
            case 'tel':
            case 'email':
            case 'number':
            case 'date':
            case 'select-one':
            case 'hidden':
                input.value = field.value;
                break;
            case 'textarea':
                input.innerText = field.value;
                break;
            case 'checkbox':
                input.checked = field.value.toUpperCase() === 'YES';
                break;
            case 'radio':
                input = document.querySelector(`[data-label="${field.name}"][value="${field.value}"]`);
                if (input) input.checked = true;
                break;
        }
    }

    for (const transaction of claimTransactions) {
        const inputSelector = `[data-label="${transaction.name}"][item-id="${transaction.item_id}"]`
        if (transaction.item_id > 1 && !document.querySelector(inputSelector)) {
            const child = document.querySelector(`[data-label="${transaction.name}"]`);
            const parent = child.closest("table");
            const parentID = parent.id.split("_")[1];
            document.getElementById("add_transactions_" + parentID).click();
        }

        // added requestAnimationFrame to ensure the input is available
        requestAnimationFrame(() => {
            let input = document.querySelector(inputSelector); // RH - changed to let since const would fail for case `radio`
            if (!input) return;

            switch (input.type) {
                case 'text':
                case 'tel':
                case 'email':
                case 'number':
                case 'date':
                case 'select-one':
                case 'hidden':
                    input.value = transaction.value;
                    break;
                case 'textarea':
                    input.innerText = transaction.value;
                    break;
                case 'checkbox':
                    input.checked = transaction.value.toUpperCase() === 'YES';
                    break;
                case 'radio':
                    input = document.querySelector(`[data-label="${transaction.name}"][value="${transaction.value}"][item-id="${transaction.item_id}"]`);
                    if (input) input.checked = true;
                    break;
            }
        })

    }

    // Handle claim files for multiple documentation sections
    if (claimFiles.length > 0) {
        // Group files by their documentation section (doc_id)
        const filesBySection = {};
        
        for (const file of claimFiles) {
            const docId = getDocId(config, file.form_id);
            if (!filesBySection[docId]) {
                filesBySection[docId] = [];
            }
            filesBySection[docId].push(file);
        }

        // Process each documentation section
        for (const [docId, files] of Object.entries(filesBySection)) {
            const list = document.getElementById(`file-list-${docId}`);
            const noFilesElement = document.getElementById(`no-files-${docId}`);
            
            if (list && files.length > 0) {
                list.classList.remove('d-none');
                if (noFilesElement) {
                    noFilesElement.classList.add('d-none');
                }

                for (const file of files) {
                    const li = document.createElement('li');
                    li.setAttribute('disabled', 'disabled');
                    li.innerHTML = `<span class="float-right badge ${file.failed ? 'bg-danger' : 'bg-success'}">${file.failed ? 'FAILED' : 'Uploaded'}</span><span class="filename"><strong>${file.name}</strong></span><span class="description">(${file.description})</span>`;
                    list.appendChild(li);
                }
            }
        }

        // Fallback for legacy single file-list support
        const legacyList = document.getElementById('file-list');
        const legacyNoFiles = document.getElementById('no-files');
        
        if (legacyList && claimFiles.length > 0) {
            legacyList.classList.remove('d-none');
            if (legacyNoFiles) {
                legacyNoFiles.classList.add('d-none');
            }

            for (const file of claimFiles) {
                const li = document.createElement('li');
                li.setAttribute('disabled', 'disabled');
                li.innerHTML = `<span class="float-right badge ${file.failed ? 'bg-danger' : 'bg-success'}">${file.failed ? 'FAILED' : 'Uploaded'}</span><span class="filename"><strong>${file.name}</strong></span><span class="description">(${file.description})</span>`;
                legacyList.appendChild(li);
            }
        }
    }

    for (const key in member) {

        if (!member.hasOwnProperty(key)) continue;

        const field = document.getElementById(key);
        if (!field) continue;

        field.value = member[key];
    }

    const country = document.getElementById('country');
    if (country.value === '') country.value = 'USA';
    if (country.value !== 'USA') {
        document.querySelectorAll('#state,#zip_code').forEach((input) => {
            toggleFieldAttribute(input, 'required', false);
            input.parentNode.classList.add('d-none');
        });
        document.querySelectorAll('#province,#postal_code').forEach((input) => {
            toggleFieldAttribute(input, 'required', true);
            input.parentNode.classList.remove('d-none');
        });
        toggleForeignPhone(true);
    }

    // if (member.claim_id) $('#confirm_email_address').val($('#email_address').val());
    if (member.claim_id) document.getElementById('confirm_email_address').value = document.getElementById('email_address').value;
}

function getDocId(config, label) {
    // return the config key whose data_file_label matches the label
    for (const key in config) {
        if (config[key].data_file_label === label) {
            return key;
        }
    }
    return 'documentation';
}